import React from "react";

import { ContentColumn } from "@app/analytics/components/reports/styles";
import MeetingReportRecapContent from "@app/analytics/MeetingReport/MeetingReportContent/MeetingReportRecapContent";
import MeetingReportHeader, {
  MeetingReportHeaderProps,
} from "@app/analytics/MeetingReport/MeetingReportHeader";

import Stack from "@rui/Stack";

import { MeetingReportOuterContainer } from "../styles";

const NotetakerReport = ({
  sessionMetadata,
  ...headerProps
}: MeetingReportHeaderProps) => {
  return (
    <MeetingReportOuterContainer>
      <MeetingReportHeader
        {...headerProps}
        sessionMetadata={sessionMetadata}
        sx={{
          borderBottom: "1px solid",
          borderColor: "shades.neutral.100",
        }}
      />
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <ContentColumn>
          <MeetingReportRecapContent isNotetakerReport />
        </ContentColumn>
      </Stack>
    </MeetingReportOuterContainer>
  );
};

export default NotetakerReport;
